import { Button, Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { scoreDescriptionToLabel } from "../../../detalhes-do-projeto/filtros/score"
// Icon
import DeleteIcon from '@mui/icons-material/Delete'
import CreditScoreIcon from '@mui/icons-material/CreditScore'

export const RecorteScoreFilterPreview = () => {
    // State
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Hook
    const { removeCreateRecorteFormFiltros } = useRecortesExtracaoService()


    const handleRemoveFilter = () => {
        removeCreateRecorteFormFiltros({ filtro: 'scoreVeles' });
    };

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Score
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="outlined"
                                startIcon={<DeleteIcon />}
                                onClick={handleRemoveFilter}
                            >
                                Remover filtro
                            </Button>
                        </Grid>
                    </Grid>

                    {createRecorteExtracaoForm.fields.Filtros &&
                        createRecorteExtracaoForm.fields.Filtros.scoreVeles && (
                            <Grid item xs={12}>
                                <Stack
                                    direction="row"
                                    flexWrap="wrap"
                                >
                                    {createRecorteExtracaoForm.fields.Filtros.scoreVeles.map((scoreVeles, i) => (
                                        <Chip
                                            key={i}
                                            icon={<CreditScoreIcon />}
                                            label={scoreDescriptionToLabel(scoreVeles).toUpperCase()}
                                            sx={{
                                                m: 0.5
                                            }}
                                        />
                                    ))}
                                </Stack>
                            </Grid>
                        )}
                </Paper>
            </Grid>
        </>
    )
}